import ADVERTISING_TYPES_API_V2 from 'api/advertising-types/v2'
import SERVICES_API_V1 from 'api/services/v1'
import { call, put, takeLatest } from 'redux-saga/effects'
import {
  FETCH_ADVERTISING_TYPES,
  FETCH_NETWORKS_DATA,
  SET_ADVERTISING_TYPES,
  SET_LOADING,
  SET_NETWORKS_LIST,
} from 'modules/Services/types'

function* onLoadData({ payload = {} }) {
  try {
    yield put({ type: SET_LOADING, payload: { loading: true } })

    const { response, error } = yield call(SERVICES_API_V1.getNetworks, payload)

    if (error) {
      throw error
    }

    yield put({
      type: SET_NETWORKS_LIST,
      payload: { networks: response.data },
    })
  } catch (error) {
    console.logXHR(error)
  } finally {
    yield put({ type: SET_LOADING, payload: { loading: false, loaded: true } })
  }
}

function* fetchAdvertisingTypes({ payload = {} }) {
  const { params } = payload
  try {
    const { response, error } = yield call(ADVERTISING_TYPES_API_V2.fetchAll, {
      params,
    })

    if (error) {
      throw error
    }

    yield put({ type: SET_ADVERTISING_TYPES, payload: response.data })
  } catch (error) {
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest(FETCH_NETWORKS_DATA, onLoadData)
  yield takeLatest(FETCH_ADVERTISING_TYPES, fetchAdvertisingTypes)
}
